// @ts-check
import { attrConfig as wId } from './w-id.js';
import { attrConfig as wDisplacedByCustomXml } from './w-displacedByCustomXml.js';

/**
 * All valid attributes for the <w:permEnd> element.
 * @type {import('@translator').AttrConfig[]}
 */
export default [wId, wDisplacedByCustomXml];
